@if (isDefaultTemplate) {
<div class="header-content">
  <div class="logo-container">
    <a [routerLink]="['landpage']" aria-label="Go to home">
      <img class="pull-left logo-title" [src]="pathToLogo" alt="Logo">
      <span class="navbar-brand header-brand" translate="PORTAL.TITLE"></span>
    </a>
  </div>
</div>
}
@else {
<div [innerHTML]="headerHTML"></div>
}
